module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_5-00c542b2fe51446e98f9753de891a8c9.png";